module.exports = __webpack_public_path__ + "static/img/button5.f6848b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button5.png
// module id = H0wX
// module chunks = 4